import {
  DashboardModuleListItem, ListItem, Text,
} from '@domain-group/suit-theme'

import useSelector from '@hooks/useSelector'

import type { SecondaryGroupModel } from '@functions/publicationEdition'

import BookingListItem from './BookingListItem'
import BrandGroupGroupActions from './BrandGroupGroupActions'

interface BrandGroupGroupProps {
  editionBrandGroup: SecondaryGroupModel,
  isLastGroup: boolean,
}

const BrandGroupGroup = (props: BrandGroupGroupProps) => {
  const { editionBrandGroup, isLastGroup } = props
  const { id: editionBrandGroupId, entityIds: editionBrandGroupBookingIds } = editionBrandGroup

  const { brandGroups } = useSelector(reduxState => reduxState.entities)

  const brandGroup = brandGroups[editionBrandGroupId] || {}

  const brandGroupBookingCount = editionBrandGroupBookingIds.length || 0
  const tertiaryText = brandGroupBookingCount === 1 ? '1 Booking' : `${brandGroupBookingCount} Bookings`

  const publicationBookings = useSelector(reduxState => reduxState.entities.publicationBookings)
  const booking = publicationBookings[editionBrandGroupBookingIds[0]] || {}
  const { publication_order_id, id: publicationBookingId } = booking

  return (
    <>
      <DashboardModuleListItem title={<Text fontWeight={600}>{brandGroup.title}</Text>}>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.TertiaryText>
          <Text color="faintGrey" display="inline-block" marginRight="medium">
            {tertiaryText}
          </Text>

          {publication_order_id && (
            <BrandGroupGroupActions
              publicationBookingId={publicationBookingId}
              publicationOrderId={publication_order_id}
            />
          )}
          {/*
         // @ts-expect-error TS2339 */}
        </DashboardModuleListItem.TertiaryText>
      </DashboardModuleListItem>

      {editionBrandGroupBookingIds.map((id: number) => (
        <BookingListItem key={id} bookingId={id} />
      ))}

      {/* A list item break between BrandGroup Groups */}
      {!isLastGroup && (
        // @ts-expect-error TS2741
        <ListItem
          disableHover
          borderColor="lineColor"
          boxProps={{ borderBottom: '1px dashed', minHeight: '51px' }}
        />
      )}
    </>
  )
}

export default BrandGroupGroup
